exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.purchased.v-list {\n\tpadding: 0;\n}\n\n/*.v-data-table__expanded__content .purchased.v-list { max-width: 85%; margin: auto; }*/\n.voided,\n.canceled {\n\ttext-decoration: line-through;\n}\n.deleted {\n\tdisplay: none\n}\n.credit .v-list-item__content {\n\tdisplay: inline;\n}\n.v-list-item .credit span {\n\tdisplay: inline;\n}\n", ""]);

// exports
